<template>

    <b-modal id="bv-new-comment" size="lg" hide-footer>
      <template #modal-title>New Comment</template>

      <div class="row">
        <div class="col">
            <textarea
                class="form-control shadow-none inputbox" 
                placeholder="Write a comment"
                rows="5"
                v-model="content"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-secondary submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Please wait ...</button>
        <button v-else type="button" class="btn btn-success submit col" @click="sendComment">Comment</button>
      </div>
        </div>
      </div>

    </b-modal>

</template> 

<script>
export default {
  props: ['article'],
  data() {
    return {
      updating: false,
      content: null,
    };
  },

  created() {
    
  },

  methods: {

    hideNewCommentModal() {
      this.$bvModal.hide('bv-new-comment');
    },

            sendComment() {

        if (this.content == null || this.content == '') {this.sweetfire('Please write a comment')}

        else {

          this.updating = true;

          axios.post('/comment/update', {
            content: this.content, 
            article_id: this.article.id,
            action: 'new'})
        .then((response) => {

          if (response.data.success) {
            this.hideNewCommentModal();
            this.content = null;
            this.$emit('get-comments');
            this.$emit('get-articles');
          } else {
            this.sweetfire(response.data.message);
          }
          
          this.updating = false;

        });

        }

      },

      showToaster(text) {
      this.$toaster.info(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>